import { DashboardDTO, DashboardLoadRequest, StopMapDTO } from '@/model';
import { apiGenericPost } from '@/service';
import { GenericPostResponse } from '@/type';
import { getApiUrl } from '@/util';

const BASE_URL = '/api/v1/dashboard/';

export const loadDashboardAPI = (
  request?: DashboardLoadRequest,
): Promise<GenericPostResponse<DashboardDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'load'), request, true);

export const loadStopsToDashboardAPI = (
  request?: DashboardLoadRequest,
): Promise<GenericPostResponse<StopMapDTO[]>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadStops'), request, true);
